import { createContext } from "react"

interface TableDisplayTarget {
  exportFilters?: string[]
  target: HTMLDivElement | null
  setTarget: (target: HTMLDivElement | null) => void
}

export const TableDisplayContext = createContext<
  TableDisplayTarget | undefined
>(undefined)
